import React from 'react';

import { Tag, Text } from 'shell/components';

const TagDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Tag</Text>
            <Tag type={'general'} value={'new'} />
            <Tag type={'invitation'} value={'pending'} />
            <Tag type={'invitation'} value={'declined'} />
            <Tag type={'invitation'} value={'expired'} />
            <Tag type={'process'} value={'inProgress'} />
            <Tag type={'progress'} value={'onTrack'} />
            <Tag type={'progress'} value={'caution'} />
            <Tag type={'progress'} value={'offTrack'} />
            <Tag type={'role'} value={'instructor'} />
            <Tag type={'status'} value={'toDo'} />
            <Tag type={'status'} value={'inProgress'} />
            <Tag type={'status'} value={'underReview'} />
            <Tag type={'submission'} value={'submitted'} />
            <Tag type={'submission'} value={'late'} />
            <Tag type={'task'} value={'milestone'} />
            <Tag type={'workload'} value={'low'} />
            <Tag type={'workload'} value={'medium'} />
            <Tag type={'workload'} value={'high'} />
        </>
    );
};

export default TagDemo;
